import TextField from '@material-ui/core/TextField';
import React from 'react';
import styled from 'styled-components';

import SecondaryRaisedButton from '../buttons/SecondaryRaisedButton';
import Text from '../common/Text';
import Translatable from '../common/Translatable';
import Heading from '../heading/Heading';
import { media } from '../styles/breakpoints';

const NewsLetterBar = () => {
    const StyledBar = styled.div`
       
        &.stolo-newsletter-bar {
            background-color: ${props => props.theme.palette.secondary.A400};
            margin: ${props => props.theme.space[12]} 0;
            padding: ${props => props.theme.space[6]} 
                     ${props => props.theme.space[10]}
                     ${props => props.theme.space[9]}
                     ${props => props.theme.space[10]};
            display: flex;
            align-items: stretch;
            justify-content: center;
          
            ${media.tweak1600up`
                margin: ${props => props.theme.space[12]} 0;
            `}
            
            ${media.wideScreenUp`
              margin: ${props => props.theme.space[12]} 0;
            `}
            
            ${media.normalPortraitUp`
              flex-direction: column;
              justify-content: center;
            `}
        }
    `;

    const StyledTextInput = styled(TextField)`
            display: inline-flex;
            flex-direction: column;
            margin: ${props => props.theme.space[3]} 0;
            width: ${props => props.theme.space[18]};
            position: relative;
            & .stolo-bar {
              background-color: rgba(255, 255, 255, 0.54);
              padding: 3px;
              margin-bottom: 3px;
            }
            & .stolo-label {
                top: 0;
                left: 0;
                position: absolute;
                transform: translate(0, 24px) scale(1);
                transition: transform 200ms cubic-bezier(0.0, 0, 0.2, 1) 0ms;
                transform-origin: top left
            }
            & .stolo-shrink {
               transform: translate(0, 1.5px) scale(0.75);
            }
        `;

    const StyledButtonWrapper = styled.div`
            display: flex;
            align-items: stretch;
            justify-content: flex-end;
            margin-left: ${props => props.theme.space[5]};
            margin-bottom: -12px;
        `;

    const StyledText = styled.div`
            width: 60%;
            margin: auto;
            text-align: center;
            ${media.normalPortraitUp`
               text-align: center;
               width: inherit;
            `}   
            & h3{
               ${media.normalPortraitUp`
                   text-align: center;
                   width: inherit;
                `}
            };
        `;

    const StyledForm = styled.form`
            display: flex;
            justify-content: center;
            align-items: center;
            ${media.normalPortraitUp`
                justify-content: center;
            `}
        `;

    return (
        <StyledBar className='stolo-newsletter-bar'>
            <Text>
                <StyledText className='stolo-inner-text'>
                    <Heading
                        text={<Translatable message='NEWSLETTER_BAR_TITLE'/>}
                        level={3}
                        center
                    />
                    <Translatable message='NEWSLETTER_BAR_TEXT'/>
                </StyledText>
                <StyledForm
                    action='//love.us12.list-manage.com/subscribe/post?u=dc31cc40dd1d2a16ee1f637d1&amp;id=c2a04ff697'
                    method='post'
                    id='mc-embedded-subscribe-form'
                    className='validate'
                    target='_blank'
                    noValidate
                >
                    <StyledTextInput
                        label={<Translatable message='LABEL_FORMFIELD_EMAIL'/>}
                        id='mce-EMAIL'
                        name='EMAIL'
                        placeholder='E-Mail'
                        required
                        type='email'
                        InputLabelProps={{
                            classes: {
                                formControl: 'stolo-label',
                                shrink: 'stolo-shrink',
                            },
                        }}
                    />
                    <StyledButtonWrapper>
                        <SecondaryRaisedButton
                            type='submit'
                            name='subscribe'
                            id='mc-embedded-subscribe'
                            disabled={false}
                            icon='gift'
                            height={'1em'}
                            text={<Translatable
                                message='LABEL_NEWSLETTER_BAR_BUTTON'
                            />}
                        />
                    </StyledButtonWrapper>
                </StyledForm>
            </Text>
        </StyledBar>
    );
};

export default NewsLetterBar;



// WEBPACK FOOTER //
// ./src/components/home/NewsLetterBar.js